export enum ExperienceTriggerEnableIf {
  always = 'always',
  firstClick = 'firstClick',
  keyword = 'keyword',
}
